import React, { useMemo, useState } from 'react'
import { BreadcrumbView } from '../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../card/card-full-height-scroll-y'
import { TableAgClient } from '../table-builder/table-ag-client'
import { ColumnDate, ColumnMenu, ColumnText } from '../table-builder/table-columns'
import { IconList, IconRecycle } from '../icon/icon'
import { Menu, MenuEmpty, MenuPermanentlyDelete, MenuRestore } from '../menu/menu'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { RecycleDelete } from './recycle-delete'
import { RecycleEmpty } from './recycle-empty'
import { recycleErrorMessage } from '../error/server-message'
import { ErrorReference } from '../error/error-reference'

export const RecycleList = ({ useApiList, useApiForm, field1, field2, canEmpty = false }) => {
  const { url } = useRouteMatch()

  const apiList = useApiList()

  const hasItems = useMemo(() => apiList.items.length !== 0, [apiList])

  const [error, setError] = useState(null)
  const [failure, setFailure] = useState(null)

  const handleReady = async () => await apiList.get('deleted')
  const handleDestroyed = () => apiList.init()

  const handleRestore = async item => {
    setError(null)
    setFailure(null)
    try {
      await apiList.put(`${item.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That item was already removed.'))
      setFailure(err)
    }
    await apiList.get('deleted')
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuEmpty to={`${url}/empty`} show={canEmpty && hasItems} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin" HeaderMenu={HeaderMenu}>
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient
            apiList={apiList}
            hideFloatingFilter
            onReady={handleReady}
            onDestoryed={handleDestroyed}
            emptyState={{ Icon: IconRecycle, title: 'The recycle bin is empty', message: 'Items you delete appear here, and can be restored until the bin is emptied.' }}>
            <ColumnDate field="deletedAt" />
            {field1 && <ColumnText field={field1} />}
            {field2 && <ColumnText field={field2} />}
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show />
                  <MenuPermanentlyDelete to={`${url}/${row.id}/purge`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      {canEmpty &&
        <Route path={`${url}/empty`}>
          <RecycleEmpty useApiList={useApiList} field1={field1} parentURL={url} />
        </Route>}

      <Route path={`${url}/:id/purge`}>
        <RecycleDelete useApiForm={useApiForm} field1={field1} parentURL={url} />
      </Route>
    </React.Fragment>
  )
}
